import { render, staticRenderFns } from "./pageBase.vue?vue&type=template&id=aa051b7e&"
import script from "./pageBase.vue?vue&type=script&lang=js&"
export * from "./pageBase.vue?vue&type=script&lang=js&"
import style0 from "./pageBase.vue?vue&type=style&index=0&id=aa051b7e&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports